<template lang="pug">
  .legend__group
    div(
      :class="className"
    )
      .legend__name.semibold {{labelText}}
    .legend__small-group
      .search-block
        input.search-block__input.input(
          type="search"
          placeholder="Наименование"
          v-model="query"
          v-debounce:300="searchList"
        )
    ul.search-block__list.reset-list(
      v-if="list.length"
    )
      li.search-block__item.type(
        v-for="item in list" :key="'list'+item.id"
      )
        .custom-checkbox
          label.custom-checkbox__label.label
            input.visually-hidden.custom-checkbox__input(
              type="checkbox"
              v-model="item.checked"
              @change="(event) => checkItem(event, item)"
            )
            span.custom-checkbox__block
            span.custom-checkbox__text {{item.name}}
    ul.search-block__list.search-block__list_checked.reset-list(
      v-if="checkedList.length"
    )
      li.search-block__item(
        v-for="item in checkedList" :key="'checked-'+item.id"
      )
        span {{item.name}}
        button.search-block__delete.reset-btn(
          @click="() => deleteFromList(item.id)"
        )
</template>

<script>
import { core } from '@/api/api-endpoints'
import SearchMapMixin from '@/mixins/search-map-mixin'
import hasMixin from '@/mixins/has-mixin'

const PER_PAGE = 10

export default {
  name: 'map-msn',
  mixins: [SearchMapMixin, hasMixin],
  props: {
    className: {
      type: String,
      default: 'legend__type legend__type_with-small',
    },
    searchType: {
      type: String,
      default: 'container',
    },
  },
  computed: {
    labelText() {
      return this.hasRouteMsnSearchType ? 'Тип контейнера' : 'Вид контейнера'
    },
  },
  methods: {
    getEndpoint(query) {
      return core.collection(this.searchType, {
        query: {
          search: query,
          'per-page': PER_PAGE,
        },
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
